"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const images_1 = require("../../services/images");
const react_1 = __importDefault(require("react"));
const ShareModal_1 = __importDefault(require("../ShareModal"));
const GoBack = (props) => {
    const [shareModalOpen, setShareModalOpen] = react_1.default.useState(false);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "go-back", children: [(0, jsx_runtime_1.jsxs)("div", { onClick: () => props.onBack(), children: [(0, jsx_runtime_1.jsx)("div", { className: "back-arrow", children: (0, jsx_runtime_1.jsx)("img", { src: images_1.icons.ArrowLeft, alt: "" }) }), props.title && (0, jsx_runtime_1.jsx)("span", { children: props.title })] }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [props.children, props.showShare && (0, jsx_runtime_1.jsx)("img", { src: images_1.icons.Share, alt: "", onClick: () => {
                                setShareModalOpen(true);
                            } }), (0, jsx_runtime_1.jsx)(ShareModal_1.default, { modalVisible: shareModalOpen, setModalVisible: setShareModalOpen })] }) })] }));
};
exports.default = GoBack;
